import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {OrderType} from 'src/app/models/OrderType';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';

interface Channel {
	name: string;
	icon: string;
	selected: boolean;
	value: OrderType | 'delivery' | 'foodspot' | PaymentMethod;
}

@Component({
	selector: 'app-order-type-filter',
	templateUrl: './order-type-filter.component.html',
	styleUrl: './order-type-filter.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTypeFilterComponent {
	isOpen = false;

	channels: Channel[] = [
		// {
		// 	name: this.translate.instant('channels.pos'),
		// 	value: OrderType.VIRTUAL,
		// 	icon: 'icon-pos',
		// 	selected: true
		// },
		{
			name: this.translate.instant('channels.sot'),
			value: OrderType.TERMINAL,
			icon: 'icon-sot',
			selected: true
		},
		{
			name: this.translate.instant('channels.app'),
			value: OrderType.PREORDER,
			icon: 'icon-app',
			selected: true
		},
		{
			name: this.translate.instant('channels.foodspot'),
			value: 'foodspot',
			icon: 'icon-foodspot',
			selected: true
		},
		{
			name: this.translate.instant('channels.delivery'),
			value: 'delivery',
			icon: 'icon-delivery',
			selected: true
		},
		{
			name: this.translate.instant('channels.wolt'),
			value: PaymentMethod.WOLT,
			icon: 'icon-wolt',
			selected: true
		},
		{
			name: this.translate.instant('channels.uber'),
			value: PaymentMethod.UBER_EATS,
			icon: 'icon-uber',
			selected: true
		},
		{
			name: this.translate.instant('channels.lieferando'),
			value: PaymentMethod.JET,
			icon: 'icon-lieferando',
			selected: true
		}
	];

	constructor(
		private managerFacade: ManagerFacade,
		private translate: TranslateService
	) {
		this.managerFacade.orderChannelsFilter$.subscribe(channelsFilter => {
			this.channels.forEach(channel => {
				channel.selected = channelsFilter.includes(channel.value);
			});
		});
	}

	toggleDropdown(): void {
		this.isOpen = !this.isOpen;
	}

	toggleSelectAll(): void {
		this.channels.forEach(c => (c.selected = false));

		this.updateFiltersInStore();
	}

	toggleChannel(channelEvent: Channel): void {
		const channel = this.channels.find(c => c.name === channelEvent.name);
		if (channel) {
			channel.selected = !channel.selected;
		}
		this.updateFiltersInStore();
	}

	areAllSelected(): boolean {
		return this.channels.every(c => c.selected);
	}

	get selectedCount(): number {
		return this.channels.filter(c => c.selected).length;
	}

	updateFiltersInStore(): void {
		this.managerFacade.updateOrderChannelFilter(
			this.channels.filter(c => c.selected).map(c => c.value)
		);
	}
}
